import { AbilityBuilder } from "@casl/ability";

const abilities = {
  Gestor: AbilityBuilder.define((can, cannot) => {
    can("manage", "all");
    cannot("create", ["MyClient", "MyTask"]);
  }),

  Assessor: AbilityBuilder.define((can, cannot) => {
    can("read", [
      "MainDashboard",
      "DashboardSpreadsheetIncome",
      "DashboardClients",
      "Dashboard",
      "MyClient",
      "MyTask",
      "MySpreadsheetIncome",
      "TriggerType",
      "UserTrigger",
      "UsefulLink",
      "MyClientPosition",
      "MyFiSwapSuggestion",
      "FiSpreadsheet",
      "AssetClassification",
      "AssetList",
    ]);
    can("create", [
      "MyClient",
      "MyTask",
      "MultipleTask",
      "ClientSpreadsheet",
      "MultipleClientEmail",
      "FiSwapSuggestion",
    ]);
    can("update", [
      "Myself",
      "MyClient",
      "MyTask",
      "MultipleClient",
      "UserTrigger",
    ]);
    can("delete", ["MyClient", "MyTask"]);
  }),

  Visitante: AbilityBuilder.define(() => {}),
};

export default abilities;
